<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">{{title}}</div>
            </div>
            <div class="modal-body" v-loading.fullscreen.lock="loading">

                <el-form ref="addForm">
                    <div>
                        <el-row >
                            <el-col :span="24" class="item" v-for="(value,j) in CheckinAssessGroup" :key="j">
                                <div class="CheckinAssessGroupTitle">
                                    <h3>{{value.name}}</h3>
                                </div>
                                <el-form-item v-for="(item,i) in value.checkinAssessGroupDTOList" :key="i" :label="(i+1)+'、'+item.name+'（最高分：'+item.maxFraction+'分）'">
                                    <el-radio-group v-model="itemCodeList[j][i]" style="width:100%;" @change="getSleep(value.name,item.name,item.checkinAssessItemList,value.checkinAssessClassCode,j,i)">
                                        <el-radio v-for="item1 in item.checkinAssessItemList"
                                            :key="item1.checkinAssessItemCode"
                                            :label="item1.checkinAssessItemCode" style="width:90%;">{{item1.name}}（{{item1.fraction}}分）</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
                <el-button type="success" @click="closeSelf">关闭</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getToken} from "@/utils/auth";


    export default {
        name: 'Add',
        props:[],
        data() {
            return {
                loading: false,
                title: '',
                itemCodeList:[],
                CheckinAssessGroup:'',
                url:'',
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    assessArr:[],
                    isSleep:1
                },
            }

        },

        methods: {
            init(row){
                this.loading=true
                var institutionCode=JSON.parse(getToken()).institutionCode;
                if(institutionCode=="62F03934-2E37-414F-AC42-E6B240E621A0" || institutionCode=="9eb78eee-6094-4a1d-ad66-4f01cd78a758"){
                    this.url=this.$institutionUrl+"ElderlyCheckinAssess/AddTongCheng"
                }else{
                    this.url=this.$institutionUrl+"ElderlyCheckinAssess/Add"
                }
                this.$refs.addForm.resetFields();
                this.addForm.elderlyCode=row.elderlyCode
                this.title=row.name+'的评估'
                this.getList()
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            getList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CheckinAssessGroup/GetListByClass",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode:getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.CheckinAssessGroup=response.data.data
                            this.itemCodeList=[]
                            this.CheckinAssessGroup.forEach(element => {
                                if(element){
                                    this.itemCodeList.push([])
                                }
                            });
                            this.loading=false
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            confirm(){
                console.log(this.addForm.assessArr)
                if(this.addForm.assessArr.length<this.CheckinAssessGroup.length){
                    this.$message({type: 'info', message: '您有选项未选择，请完成评估'});
                    return

                }
                /*for(var i in this.addForm.assessArr){
                    if(this.addForm.assessArr[i].itemArrCode.length<this.CheckinAssessGroup[i].checkinAssessGroupDTOList.length){
                        this.$message({type: 'info', message: '您有选项未选择，请完成评估'});
                        return
                    }
                }*/
                for(var i in this.addForm.assessArr){
                  if(this.addForm.assessArr[i].itemArrCode.length == this.CheckinAssessGroup[i].checkinAssessGroupDTOList.length){
                    for(let j=0; j<this.CheckinAssessGroup[i].checkinAssessGroupDTOList.length;j++ ){
                      if(this.addForm.assessArr[i].itemArrCode[j] === undefined){
                        this.$message({type: 'info', message: '您有选项未选择，请完成评估'});
                        return
                      }
                    }
                  }else {
                    this.$message({type: 'info', message: '您有选项未选择，请完成评估'});
                    return
                  }
                }
                this.addSubmit();
            },
            getSleep(valueName,itemName,list,code,j,i){
                if(this.addForm.assessArr[j]){
                    this.addForm.assessArr[j].classCode=code
                    this.addForm.assessArr[j].itemArrCode[i]=this.itemCodeList[j][i]
                }else{
                    var item={classCode:code,itemArrCode:[]}
                    item.itemArrCode[i]=this.itemCodeList[j][i]
                    this.addForm.assessArr[j]=item
                }
                if(valueName=='感知觉与沟通能力'){
                    if(itemName=='意识水平'){
                        list.forEach(element => {
                            if(this.itemCodeList[j][i]==element.checkinAssessItemCode){
                                if(element.fraction==3){
                                    this.addForm.isSleep=2
                                }else{
                                    this.addForm.isSleep=1
                                }
                            }
                        });
                    }
                }
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.url,
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.addForm.assessArr=[]
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: center;
                padding: 10px;
                font-size: 20px;
                display: flex;
            }
            .modal-body /deep/ .el-form-item__label{
                font-size: 16px;
            }
            .modal-body /deep/ .el-radio{
                font-size: 16px;
                padding: 10px;
            }
            .CheckinAssessGroupTitle{
                text-align: center;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: scroll;
                max-height: 500px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
            }


        }

    }


    // .btn-close, .btn-confirm {
    //     border-radius: 8px;
    //     margin-left:16px;
    //     width:56px;
    //     height: 36px;
    //     border:none;
    //     cursor: pointer;
    // }
    // .btn-close {
    //     color: #313131;
    //     background-color:transparent;
    // }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
